import { Route, Routes, useLocation } from 'react-router';
import AccountGeneral from 'src/pages/account';
import { useEffect } from 'react';
import CompetitorsMonitoring from 'src/pages/dashboards/competitorsMonitoring';
import CompetitorFocus from 'src/pages/dashboards/competitorFocus';
import GlobalTextAds from 'src/pages/dashboards/globalTextAds';
import GlobalPlaAds from 'src/pages/dashboards/globalPlaAds';
import BusinessOverview from 'src/pages/dashboards/businessOverview';
import BrandOverview from 'src/pages/dashboards/brandOverview';
import TrafficAnalysis from 'src/pages/dashboards/trafficAnalysis';
import TrafficDetails from 'src/pages/dashboards/trafficDetails';
import AdminUsers from 'src/pages/admin/users';
import Workspace from 'src/pages/workspaces';
import Join from 'src/pages/workspaces/join';
import Users from 'src/pages/workspaces/users';
import { useCurrentUserQuery } from 'src/context/api/auth';
import Competitor from 'src/sections/overview/dashboards/views/competitor';
import AdminScrapping from 'src/sections/overview/dashboards/views/admin/scrapping/scraping';
import Error404 from 'src/pages/error/404';
import KeywordBased from 'src/sections/overview/dashboards/views/keywordBased';
import CampaignBased from 'src/sections/overview/dashboards/views/campaignBased';
import AdGroupBased from 'src/sections/overview/dashboards/views/adGroupBased';
import CampaignExplorer from 'src/sections/overview/dashboards/views/campaign-explorer';
import { useDispatch, useSelector } from 'react-redux';
import { fDate } from 'src/utils/format-time';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import { useGetAdsPlaGlobalQuery, useGetAdsTxtGlobalQuery, useGetBrandsQuery } from 'src/context/api/competitorsMonitoring/api';
import { setNotificationBrandInNonBrandCampaigns, setNotificationBrandInfringement, setNotificationBrandInfringementNotification, setNotificationBrandInfringementNotificationTXT, setNotificationBrandInfringementTXT } from 'src/context/reducers/filter-settings/filterSlice';
import DataNotAvailable from 'src/pages/dashboards/dataNotAvailable';
import { useGetBrandInNonBrandCampaignsQuery } from 'src/context/api/campaignExplorer/api';
import SsoIntegrationsList from 'src/pages/admin/sso';
import { paths } from './paths';
import Banners from 'src/sections/overview/dashboards/views/admin/onboard/views/banners';
import BannerAdd from 'src/sections/overview/dashboards/views/admin/onboard/views/add';
import { adminFeaturePaths } from './adminFeaturePaths';
import { dashboardPaths } from './dashboardPaths';
import Section from 'src/components/section';
import ActivationsAnalyzeView from 'src/sections/overview/dashboards/activations/analyze/view';
import CompetitiveOverview from 'src/sections/overview/dashboards/views/competitiveIntelligence/overview';
import ConversionsAnalysis from 'src/sections/overview/dashboards/views/conversionsAnalysis';
import { AdsWithProvider, CompetitiveLandscapeWithProvider, SearchTermsAnalysisWithProvider } from 'src/components/competitive-intelligence';
import WorkspaceSetup from 'src/sections/workspaces/view/setup';

export default function Router() {
  const user: any = useCurrentUserQuery();
  const role = user?.data?.role;
  const filterStore = useSelector((state: any) => state.filters);
  const workspace: any = useCurrentWorkspace();
  const dispatch = useDispatch();

  const { data: brands, error: brandsError, isLoading: isLoadingBrands, isFetching: isFetchingBrands } = useGetBrandsQuery(
    { bqTable: workspace?.bqTable },
    { skip: !workspace?.bqTable }
  );

  const { data: brandInNonBrandCampaigns, error: brandInNonBrandCampaignsError, isLoading: isLoadingBrandInNonBrandCampaigns, isFetching: isFetchingBrandInNonBrandCampaigns } = useGetBrandInNonBrandCampaignsQuery(
    {
      client: workspace?.bqTable,
      brands: Array.isArray(brands) ? brands : [],
    },
    {
      skip: !workspace?.bqTable || !Array.isArray(brands) || brands.length === 0,
    }
  );

  useEffect(() => {
    if (brandInNonBrandCampaigns && brandInNonBrandCampaigns?.length > 0) {
      dispatch(setNotificationBrandInNonBrandCampaigns(true))
    }

  }, [brandInNonBrandCampaigns])

  const {
    data: adsNotificationBrandInfringement,
    error: adsNotificationBrandInfringementError,
    isFetching: isFetchingAdsNotificationBrandInfringement,
    isLoading: isLoadingAdsNotificationBrandInfringement
  }: any = useGetAdsPlaGlobalQuery(
    {
      startDate: filterStore.start ? fDate(filterStore.start, "yyyy-MM-dd") : null,
      endDate: filterStore.end ? fDate(filterStore.end, "yyyy-MM-dd") : null,
      device: filterStore.devices.map((device: string) => device.toLowerCase()),
      countries: filterStore.countries,
      domain: "all",
      workspaceTable: workspace?.bqTable,
      keywords: filterStore?.keywords,
      otherDomains: workspace?.friendlyDomains,
      advertizer: filterStore?.advertizersPLA,
      impressionShare: filterStore?.impressionSharePLA,
      domains: filterStore?.domainsPLA,
      ratingRange: filterStore?.ratingRangePLA,
      priceRange: filterStore?.pricingRangePLA || [0, 50000],
      position: filterStore?.averagePositionPLA,
      brands: brands,
      platform: filterStore?.platforms
    },
    {
      skip: workspace?.showPlaAlert !== true, // Skipper si la condition n'est pas remplie
    }
  );

  useEffect(() => {
    if (adsNotificationBrandInfringement?.ads?.length !== 0) {
      dispatch(setNotificationBrandInfringement(true))
      dispatch(setNotificationBrandInfringementNotification(adsNotificationBrandInfringement))
    }
  }, [adsNotificationBrandInfringement])


  const {
    data: adsNotificationBrandInfringementTXT,
    error: adsNotificationBrandInfringementTXTError,
    isFetching: isFetchingAdsNotificationBrandInfringementTXT,
    isLoading: isLoadingAdsNotificationBrandInfringementTXT
  }: any = useGetAdsTxtGlobalQuery(
    {
      startDate: filterStore.start ? fDate(filterStore.start, "yyyy-MM-dd") : null,
      endDate: filterStore.end ? fDate(filterStore.end, "yyyy-MM-dd") : null,
      device: filterStore.devices.map((device: string) => device.toLowerCase()),
      countries: filterStore.countries,
      domain: "all",
      workspaceTable: workspace?.bqTable,
      keywords: filterStore?.keywords,
      otherDomains: workspace?.friendlyDomains,
      impressionShare: filterStore?.impressionShareTXT,
      domains: filterStore?.domainsTXT,
      position: filterStore?.averagePositionTXT,
      brands: brands,
      platform: filterStore?.platforms
    },
    {
      skip: workspace?.showTxtAlert !== true, // Skipper si la condition n'est pas remplie
    }
  );

  useEffect(() => {
    if (adsNotificationBrandInfringementTXT?.ads?.length !== 0) {
      dispatch(setNotificationBrandInfringementTXT(true))
      dispatch(setNotificationBrandInfringementNotificationTXT(adsNotificationBrandInfringementTXT))

    }
  }, [adsNotificationBrandInfringementTXT])

  return (
    <Routes>
      {/*  */}
      <Route path="/" element={<Section children={<Workspace />} />} />
      <Route path={dashboardPaths.trafficAnalysis} element={<Section children={<TrafficAnalysis />} />} />
      <Route path={dashboardPaths.trafficDetails} element={<Section children={<ActivationsAnalyzeView />} />} />
      {/*  */}
      <Route path={dashboardPaths.competitorsMonitoring} element={<Section children={<CompetitorsMonitoring />} />} />
      <Route path={dashboardPaths.competitorFocus} element={<Section children={<CompetitorFocus />} />} />
      <Route path={dashboardPaths.competitorDomain} element={<Section children={<Competitor />} />} />
      {/*  */}
      <Route path={dashboardPaths.businessOverview} element={<Section children={<BusinessOverview />} />} />
      <Route path={dashboardPaths.brandOverview} element={<Section children={<BrandOverview />} />} />

      <Route path={dashboardPaths.conversionsAnalysis} element={<Section children={<ConversionsAnalysis />} />} />

      <Route path={dashboardPaths.textAds} element={<Section children={<GlobalTextAds />} />} />
      <Route path={dashboardPaths.productListingAds} element={<Section children={<GlobalPlaAds />} />} />
      {/*  */}

      <Route path={dashboardPaths.campaignExplorer} element={<Section children={<CampaignExplorer />} />} />

      <Route path={dashboardPaths.competitiveIntelligence} element={<Section children={<CompetitiveOverview />} />} />
      <Route path={dashboardPaths.competitiveLandscape} element={<Section children={<CompetitiveLandscapeWithProvider />} />} />
      <Route path={dashboardPaths.competitiveSearchTermAnalysis} element={<Section children={<SearchTermsAnalysisWithProvider />} />} />
      <Route path={dashboardPaths.competitiveAds} element={<Section children={<AdsWithProvider />} />} />

      {["admin", "brand specialist", "consultant"].includes(role) && (
        <>
          {/*  */}
          <Route path="/admin/users" element={<Section children={<AdminUsers />} />} />
          <Route path="/admin/users/add" element={<Section children={<AdminUsers />} />} />
        </>
      )}
      {role === "admin" && (
        <>
          <Route path={paths.admin.sso.list} element={<Section children={<SsoIntegrationsList />} />} />
          <Route path={paths.admin.onboard.banners.list} element={<Section children={<Banners />} />} />
          <Route path={paths.admin.onboard.banners.add} element={<Section children={<BannerAdd />} />} />
        </>
      )}
      {["admin", "brand specialist"].includes(role) && (
        <>
          <Route path={paths.admin.workspacesSetup} element={<Section children={<WorkspaceSetup />} />} />
          <Route path={paths.admin.workspacesSetupEdit} element={<Section sx={{ height: '100vh', pb: 0 }} children={<WorkspaceSetup />} />} />
          {/*  */}
          <Route path={adminFeaturePaths.liveMonitoring} element={<Section children={<AdminScrapping />} />} />
          <Route path={adminFeaturePaths.liveMonitoringAdd} element={<Section children={<AdminScrapping />} />} />
          {/*  */}
          <Route path={adminFeaturePaths.liveBiddingSearchActiveMode} element={<Section children={<KeywordBased />} />} />
          <Route path={adminFeaturePaths.liveBiddingSearchKoBiddingMaxCpc} element={<Section children={<KeywordBased />} />} />
          <Route path={adminFeaturePaths.liveBiddingSearchKoBiddingTroas} element={<Section children={<KeywordBased />} />} />
          <Route path={adminFeaturePaths.liveBiddingSearchKoBiddingTcpa} element={<Section children={<KeywordBased />} />} />
          <Route path={adminFeaturePaths.liveBiddingSearchKoBiddingTargetImpressionShare} element={<Section children={<KeywordBased />} />} />
          <Route path={adminFeaturePaths.liveBiddingSearchKoBiddingAuto} element={<Section children={<KeywordBased />} />} />

          <Route path={adminFeaturePaths.liveBiddingCampaignBased} element={<Section children={<CampaignBased />} />} />
          <Route path={adminFeaturePaths.liveBiddingAdGroupBased} element={<Section children={<AdGroupBased />} />} />
          {/*  */}
        </>
      )}

      <Route path="/account" element={<Section children={<AccountGeneral />} />} />
      <Route path='/data-not-available' element={<Section children={<DataNotAvailable />} />} />
      <Route path='/workspaces' element={<Section children={<Workspace />} />} />
      <Route path='/workspaces/add' element={<Section children={<Workspace />} />} />
      {/*  */}
      <Route path='/workspaces/:id/invitations/:token' element={<Section children={<Join />} />} />
      <Route path='/workspaces/:id/invitations/:token' element={<Section children={<Join />} />} />
      <Route path='/workspaces/:id' element={<Section children={<Users />} />} />
      {/*  */}

      <Route path="*" element={<Section children={<Error404 />} />} />
    </Routes>
  );
}
